export interface IModuleOption {
	readonly label: string;
	readonly value: string;
	readonly groupName: string;
	readonly position: number;
}

export class ModuleOption implements IModuleOption {
	private _label: string;
	private _value: string;
	private _groupName: string;
	private _position: number;

	constructor(
		label: string,
		value: string,
		groupName: string,
		position: number
	) {
		this._label = label;
		this._value = value;
		this._groupName = groupName;
		this._position = position;
	}

	public get label(): string {
		return this._label;
	}

	public get value(): string {
		return this._value;
	}

	public get groupName(): string {
		return this._groupName;
	}

	public get position(): number {
		return this._position;
	}
}
